/** 行全体をクリック可能にしたとき、行内の操作要素と取り違えないための判定。 */
const INTERACTIVE_SELECTOR =
  "button, a, input, select, textarea, [role='button']";

/**
 * クリックの発生元が「それ自体が操作を持つ要素」か。
 *
 * 行の onClick でこれを弾かないと、行内のボタンを押したときに行の処理と
 * ボタンの処理が二重に走る（チェックボックスならすぐ閉じてしまう）。
 */
export function isInteractiveTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;

  return target.closest(INTERACTIVE_SELECTOR) !== null;
}
